import { addObservable } from '@/store/core/thunks/addObservable.ts'
import { DefaultRootState } from '@/store/coreReducer.ts'
import { StateKeys, StoreType } from '@/store/store.ts'
import { isEqual } from 'lodash-es'
import { debounceTime, distinctUntilChanged, from, map, pairwise } from 'rxjs'

import { persistableItems } from './persistableItems'

export const persistedObserver = async (store: StoreType) => {
	console.info('[booking-system:state]: Creating persist observer.')

	const state$ = from(store)

	const toPersist: StateKeys[] = []

	persistableItems.forEach(item => {
		const state = store.getState()
		if (item in state) {
			toPersist.push(item as StateKeys)
		}
	})

	const stateObservable$ = state$.pipe(
		debounceTime(250),
		distinctUntilChanged((prev, curr) => {
			// console.log('change triggered')
			return !toPersist.some(item => {
				if (!isEqual(prev[item], curr[item])) {
					const itemString = item as string
					console.debug('[booking-system:state]: Triggering persist because of state property: ' + itemString + '')
					return true
				}
				return false
			})
		}),
		pairwise(),
		map(([prev, curr]) => {
			let partial: Partial<DefaultRootState> = {}
			toPersist.forEach(item => {
				if (!isEqual(prev[item], curr[item])) {
					partial = {
						...partial,
						[item]: curr[item],
					}
				}
			})
			return partial
		}),
	)
	return store.dispatch(addObservable([{ type: 'root', observable: stateObservable$ }]))
}
